import React from 'react';
import SeenEmailIcon from '../../../../../../../shared/components/images/seen';
import SentEmailIcon from '../../../../../../../shared/components/images/sent-email-icon';

type IProps = {
  sentCount: number;
  openCount: number;
};

const PerformanceRenderer: React.FC<IProps> = ({ sentCount, openCount }) => (
  <div className="performance-wrapper d-flex">
    <div className="template-performance mr-2">
      <SentEmailIcon />
      <span className="ml-1 mr-1 regular-1">{sentCount}</span>
    </div>
    <div className="template-performance">
      <SeenEmailIcon />
      <span className="ml-1 mr-1 regular-1">{openCount}</span>
    </div>
  </div>
);

export default PerformanceRenderer;
